import { Box, Paper, Typography } from '@mui/material'
import { Loader } from 'Common/Loader/Loader'
//import { useStyles } from './EditCapacity.styles'

export const PlanDataIsLoading = () => {
  //const classes = useStyles()
  return (
    <>
      <Paper>
        <Box>
          <Loader />
        </Box>
        <Box mb={2} display="flex" justifyContent="center">
          <Typography variant="h2">Plan data is loading.</Typography>
        </Box>
        <Box mb={4} display="flex" justifyContent="center">
          <Typography variant="h4">
            This may take a while. You can return to this screen after a few
            minutes.
          </Typography>
        </Box>
      </Paper>
    </>
  )
}
